var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.00024C17.5913 8.00024 19.1174 8.63239 20.2426 9.7576C21.3679 10.8828 22 12.4089 22 14.0002V21.0002H18V14.0002C18 13.4698 17.7893 12.9611 17.4142 12.586C17.0391 12.211 16.5304 12.0002 16 12.0002C15.4696 12.0002 14.9609 12.211 14.5858 12.586C14.2107 12.9611 14 13.4698 14 14.0002V21.0002H10V14.0002C10 12.4089 10.6321 10.8828 11.7574 9.7576C12.8826 8.63239 14.4087 8.00024 16 8.00024Z",
    fill: "#FFC794"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.00024H2V21.0002H6V9.00024Z",
    fill: "#FFC794"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.00024C5.10457 6.00024 6 5.10481 6 4.00024C6 2.89567 5.10457 2.00024 4 2.00024C2.89543 2.00024 2 2.89567 2 4.00024C2 5.10481 2.89543 6.00024 4 6.00024Z",
    fill: "#FFC794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6b42f61f3e085611bb2ad5819ce9dbda.svg";
export { ForwardRef as ReactComponent };